import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'
import find from 'lodash/find'
import get from 'lodash/get'
import { Input } from 'reactstrap'

import moment from '../../../../lib/moment.js'
import { leaveColor } from '../../helpers/color'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'

const sumTotalHours = (times) => {
  let sum = 0
  Object.keys(times).map(time => {
    sum += Number(times[time].hours)
    return time
  })
  return sum
}

export const DataInput = (props) => {
  const { projectID, taskID, task, project, holidays,
    leaveRequests, compensateRequests, invalidList } = props
  const { isEdit } = props
  const { editHour, handleClickCell } = props
  const maximumWorkingHoursPerDay = get(props, 'maximumWorkingHoursPerDay', [])
  const isSubcontract = get(props, 'authData.user.employee_type') === 'Subcontract'

  return (
    <Column>
      <Total>{ sumTotalHours(get(task, 'times', [])) }</Total>
      { get(task, 'times', []).map((time, timeID) => {
        let day = ''
        const id = shortid()
        const invalid = find(invalidList, { timeID: moment(time.date).format('YYYY-MM-DD') })
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidays, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)
        const leaveCondition = !isWeekend
        && !isHoliday
        && ((hasLeave.length === 1 && hasLeave[0].leave_time !== 'FULLDAY') || !hasLeave)
        const compensateCondition = (isWeekend && hasCompensate) || (isHoliday && hasCompensate)
        const show = ((leaveCondition || compensateCondition)
        && maximumWorkingHoursPerDay[moment(time.date).format('YYYY-MM-DD')].hours > 0)
        || ((isWeekend || isHoliday) && isSubcontract)

        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            day={ day }
            canClick={ (isHoliday || hasLeave || hasCompensate) && !show }
            onClick={
              (isHoliday || hasLeave || hasCompensate) && !show ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            { show &&
            <InputField
              id={ id }
              type='number'
              step='0.5'
              value={ time.hours }
              invalid={ invalid }
              onFocus={ () => document.getElementById(id).select() }
              onChange={ (e) => {
                if (e.target.value < 0 || e.target.value === '') e.target.value = 0
                else if (e.target.value > 8) e.target.value = 8
                else e.target.value = parseFloat(e.target.value)
                editHour(e, taskID, timeID, projectID, false)
              }
              }
              // onBlur={ (e) => editHour(e, taskID, timeID, projectID, true) }
              disabled={ !isEdit }
            />
            }
          </Cell>
        )
      }) }
    </Column>
  )
}

export const EmptyInput = (props) => {
  const { holidays, project, leaveRequests, compensateRequests, task } = props
  const { handleClickCell } = props
  const sumTotalProject = get(props, 'sumTotalProject')

  return (
    <Column>
      <Total
        style={ { paddingTop: 10, fontFamily: FONTS.GOTHAM_MEDIUM } }
      >{ sumTotalProject || '' }</Total>
      { get(task, 'times', []).map(time => {
        let day = ''
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidays, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)

        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Date />
          </Cell>
        )
      }) }
    </Column>
  )
}

DataInput.propTypes = {
  projectID: PropTypes.string,
  editHour: PropTypes.func.isRequired,
  handleClickCell: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  task: PropTypes.object,
  taskID: PropTypes.number,
  holidays: PropTypes.array,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  invalidList: PropTypes.array,
  project: PropTypes.object,
}
DataInput.defaultProps = {
  projectID: '',
  taskID: 0,
  isEdit: false,
  task: {},
  project: {},
  holidays: [],
  leaveRequests: [],
  compensateRequests: [],
  invalidList: [],
}
EmptyInput.propTypes = {
  holidays: PropTypes.array,
  task: PropTypes.object,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
}
EmptyInput.defaultProps = {
  holidays: [],
  task: {},
  leaveRequests: [],
  compensateRequests: [],
  project: {},
}

const InputField = styled(Input)`
  background-image: none !important;
  width: 90%;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 0px !important;
  text-align: center;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const Column = styled.div`
  min-height: fit-content;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => { return props.canClick ? 'pointer' : 'default' }};
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
  background-color: ${(props) => { return leaveColor(props.day) }};
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
`
const Date = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/input-col.js